export default {"src":"/_next/static/media/tikTok.2e1140f5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};